var CustomCollectionFilterModel = /** @class */ (function () {
    function CustomCollectionFilterModel(filterType, title, options) {
        this.filterType = filterType;
        this.title = title;
        this.options = options;
        this.selectedCollectionId = [];
    }
    CustomCollectionFilterModel.prototype.update = function (optionId) {
        /* istanbul ignore next: todo(daniela): test this */
        if (this.selectedCollectionId.indexOf(optionId) === -1) {
            this.selectedCollectionId.push(optionId);
        }
        else {
            var index = this.selectedCollectionId.indexOf(optionId);
            this.selectedCollectionId.splice(index, 1);
        }
    };
    CustomCollectionFilterModel.prototype.hasSelectedCollectionIds = function () {
        return !!this.selectedCollectionId.length;
    };
    CustomCollectionFilterModel.prototype.reset = function () {
        this.selectedCollectionId = [];
    };
    return CustomCollectionFilterModel;
}());
export { CustomCollectionFilterModel };
//# sourceMappingURL=customCollectionFilterModel.js.map